export const createRuleId = () => {
  const randomId =
    typeof crypto !== 'undefined' && crypto.randomUUID
      ? crypto.randomUUID()
      : `${Date.now()}_${Math.random().toString(36).slice(2)}`;
  return `rule_${randomId}`;
};

export const createRule = ({ content, templateKey = null }) => ({
  id: createRuleId(),
  content,
  template_key: templateKey,
});

export const hasTemplateRule = (rules, templateKey) =>
  Boolean(templateKey && rules.some(rule => rule.template_key === templateKey));

export const updateRuleContent = (rules, id, content) =>
  rules.map(rule => (rule.id === id ? { ...rule, content } : rule));

export const deleteRuleById = (rules, id) =>
  rules.filter(rule => rule.id !== id);
